module.exports = __webpack_public_path__ + "static/will_o_wisp-9ac9980ddd37c7dfbb0fdcb189a29c1b.jpg";